import type { Config } from '../../_config'
import { Language } from '../domain/Language'
import { Market } from '../domain/Market'
import { CookieSharedRepository } from './CookieSharedRepository'
import { DomainSharedRepository } from './DomainSharedRepository'
import { ForbiddenSharedRepository } from './ForbiddenSharedRepository'
import { HeaderSharedRepository } from './HeaderSharedRepository'
import { QueryParamSharedRepository } from './QueryParamSharedRepository'

export class SharedRepositoryProxy extends ForbiddenSharedRepository {
  static create({ config }: { config: Config }) {
    return new SharedRepositoryProxy(
      config,
      QueryParamSharedRepository.create({ config }),
      CookieSharedRepository.create({ config }),
      DomainSharedRepository.create({ config }),
      HeaderSharedRepository.create({ config })
    )
  }

  constructor(
    config: Config,
    private readonly queryParamSharedRepository: QueryParamSharedRepository,
    private readonly cookieSharedRepository: CookieSharedRepository,
    private readonly domainSharedRepository: DomainSharedRepository,
    private readonly headerSharedRepository: HeaderSharedRepository
  ) {
    super(config)
  }

  async market() {
    const paramMarket = await this.queryParamSharedRepository.market()

    if (!paramMarket.isEmpty()) return paramMarket

    const domainMarket = await this.domainSharedRepository.market()

    if (!domainMarket.isEmpty()) return domainMarket

    const cookieMarket = await this.cookieSharedRepository.market()

    if (!cookieMarket.isEmpty()) return cookieMarket

    return Market.default()
  }

  async language() {
    const paramLanguage = await this.queryParamSharedRepository.language()

    if (!paramLanguage.isEmpty()) return paramLanguage

    const cookieLanguage = await this.cookieSharedRepository.language()

    if (!cookieLanguage.isEmpty()) return cookieLanguage

    const market = await this.market()
    const marketLanguage = Language.fromMarket(market.value)

    if (!marketLanguage.isEmpty()) return marketLanguage

    const headersLanguage = await this.headerSharedRepository.language()

    if (!headersLanguage.isEmpty()) return headersLanguage

    return Language.default()
  }

  async partialSearch() {
    return this.queryParamSharedRepository.partialSearch()
  }

  async affiliate() {
    return this.cookieSharedRepository.affiliate()
  }
}
